import { SVGProps } from "react"
import { twMerge } from "tailwind-merge"

const IconSettings = ({ className, ...props }: SVGProps<SVGSVGElement> & { className?: string }) => {
  return (
    <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={twMerge("size-4", className)} {...props}>
      <path d="M1 3H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M1 15H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M1 9H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="6" cy="3" r="2.25" fill="white" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="6" cy="15" r="2.25" fill="white" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="14" cy="9" r="2.25" fill="white" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  )
}

export default IconSettings
